
import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { StudentHistoryComponent } from '../student-history/student-history.component';


@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss']
})
export class ChatComponent implements OnInit {
  panelOpenState = true;
  @Input() data: string;
  ScrutinyPopForm: FormGroup;
  APIService: any;
  filteredListExam: any;
  examList: any;
  filteredSrtyList: any;
  SrtyList: any;
  submitpayload: any;
  UpdateBtn = false;
  Arr = [];
  dialogRef1: MatDialogRef<any>;
  Data: any;
  FinalApp: any;
  randomNum: number;
  assignLevelData
  uuuID
  errmessage
  showwMessage = false;
  TabVisible: boolean;
  documentDropdownVisible: boolean;
  selectedItems: any[];
  filtereddocumentList: any;
  documentList: any;
  tabsString: any;
  docString: any;
  tabselected: any;
  isdisabled = false;
  laterEntry
  FeesBeforeScrutiny: boolean;
  constructor(private dialog: MatDialog, public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder, public router: Router,
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.UpdateBtn = false;
    this.tabselected = '' 
    this.Arr = Object.assign({}, ...this.data);
    
    this.ScrutinyPopForm = this.fb.group({
      Srty: new FormControl('', Validators.required),
      Text: new FormControl('', Validators.required),
      DocErrBy: new FormControl(''),
      StuSrNo: new FormControl(''),
      Tabs: new FormControl(''),

    });
    this.getSecretData()
    this.fetchSrty();
    this.checkLock();

  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      let activeFlowObject = res.projectPharam['ActiveFlow']
        let arrActiveFlow = JSON.parse(activeFlowObject);
        if(arrActiveFlow[0]['FeesBeforeScrutiny'] == 1){
          this.FeesBeforeScrutiny = true;
        }
        else if(arrActiveFlow[0]['FeesBeforeScrutiny'] == 0){
          this.FeesBeforeScrutiny = false;
        }
    
      
    })
  }

  checkLock() {
    this.spinner.show()
    this.UpdateBtn = false;
    const payload = {};
    payload['UserId'] = parseInt(this.Arr['UserId']);
    payload['StudentId'] = parseInt(this.Arr['StdId']);
    payload['SessionId'] = parseInt(this.Arr['SessionId']);
    this.umsService.ScrutinyLock(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Data = res.data[0]
        if (this.Data.Status == 'APPR' && this.Data.FinalApproval == true && this.Arr['UserId'] == this.Data.HistoryUserId) {
          if(this.FeesBeforeScrutiny == true){
            this.UpdateBtn = false
            this.isdisabled = false
          }
          else if(this.FeesBeforeScrutiny == false){
            this.UpdateBtn = true
          }
          // this.UpdateBtn = true;
        }
        else {
          this.UpdateBtn = false;
        }
      } else {
        this.spinner.hide()
        this.UpdateBtn = false;
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      this.UpdateBtn = false;
    });

  }

  fetchSrty() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SRTY';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.SrtyList = res.data;
        this.filteredSrtyList = this.SrtyList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  TabSelected(data){  //called when document upload tab is selected for scrutiny error
    this.tabselected = data
  }

  submit() {
    if (this.ScrutinyPopForm.invalid) {
      this.ScrutinyPopForm.get('Srty').markAsTouched();
      this.ScrutinyPopForm.get('Text').markAsTouched();
      this.submitpayload = this.ScrutinyPopForm.value;
      if(this.submitpayload.Srty == 'DCERR'){
        this.ScrutinyPopForm.get('Tabs').setValidators([Validators.required]);
        this.ScrutinyPopForm.get('Tabs').updateValueAndValidity();
        this.ScrutinyPopForm.get('Tabs').markAsTouched();
        this.ScrutinyPopForm.get('StuSrNo').clearValidators();
        this.ScrutinyPopForm.get('StuSrNo').updateValueAndValidity();
        
      }
      else{
        this.ScrutinyPopForm.get('Tabs').clearValidators();
        this.ScrutinyPopForm.get('Tabs').updateValueAndValidity();
        this.ScrutinyPopForm.get('StuSrNo').clearValidators();
        this.ScrutinyPopForm.get('StuSrNo').updateValueAndValidity();
      }
      
     

      return;
    } else {
      if(this.tabselected == 'Document Upload' && this.ScrutinyPopForm.value['StuSrNo'] == ''){
        this.ScrutinyPopForm.get('StuSrNo').setValidators([Validators.required]);
        this.ScrutinyPopForm.get('StuSrNo').updateValueAndValidity();
        this.ScrutinyPopForm.get('StuSrNo').markAsTouched();
      }
      else if(this.tabselected == 'Document Upload'  && this.ScrutinyPopForm.value['StuSrNo'] != ''){
        this.submitFinal();
        this.ScrutinyPopForm.get('StuSrNo').clearValidators();
        this.ScrutinyPopForm.get('StuSrNo').updateValueAndValidity();
        
      }
      else if(this.tabselected == ''  && this.ScrutinyPopForm.value['StuSrNo'] != ''){
        this.submitFinal();
        this.ScrutinyPopForm.get('StuSrNo').clearValidators();
        this.ScrutinyPopForm.get('StuSrNo').updateValueAndValidity();
        
      }
      else{
        this.submitFinal();
      }
      
    }
  }

  submitFinal() {
    this.spinner.show()
    this.FinalApp = ''
    const payload = {};
    payload['UserId'] = parseInt(this.Arr['UserId']);
    payload['StudentId'] = parseInt(this.Arr['StdId']);
    payload['SessionId'] = parseInt(this.Arr['SessionId']);
    this.umsService.ScrutinyLock(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Data = res.data[0]
        this.submitpayload = this.ScrutinyPopForm.value;
        this.FinalApp = this.Data.FinalApproval
        //if approved then check whether its done by last level user and if its final approval so for that
        //Step 1)first check whether registration list is open so after approval student will be registered 
        if (this.submitpayload.Srty == 'APPR' && this.Data.FinalApproval == true) {
          if(this.FeesBeforeScrutiny == true){
            this.submitScrutiny();
          }
          else if(this.FeesBeforeScrutiny == false){
            this.courseShId();  //called to check course schedule
          }
          
        }
        //if other than approval then directly hit scrutniy api
        else if (this.submitpayload.Srty == 'DCERR' || this.submitpayload.Srty == 'APPR' || this.submitpayload.Srty == 'REJT' || this.submitpayload.Srty == 'BCKP') {
          this.submitScrutiny();
        }
      }
      else {
        this.spinner.hide()
        // this.courseShId();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  courseShId() {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.Arr['CoCode'];
    payload['CShStatus'] = '';
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['CShSnNo'] = parseInt(this.Arr['SessionId']);
    this.umsService.NewCoSch(payload).subscribe(res => {
      //Step 2)if course is scheduled then check registration list open or not else show error message.
      if (res.status) {
        this.spinner.hide()
        this.checkRegister(res.data[0]['CShId'])
      }
      else{
        this.spinner.hide()
        let data = {}
        data['message'] = "Course Not Scheduled"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  checkRegister(ShId) {
    this.spinner.show()
    const payload = {};
    payload['CEcInCode'] = 51;
    payload['CEcShId'] = ShId;
    payload['CEcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
      //Step 3)check whether regitration list open or updated to show validation message. if open then hit scrutiny api
      if (res.status) {
        this.spinner.hide()
        if (res.data[0].CEcStatus == "U") {
          let data = {}
          data['message'] = "Registration closed"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        } else {  //this condition defines that registration list is open
          this.submitScrutiny();
        }
      }
      else {
        this.spinner.hide()
        let data = {}
        data['message'] = "Registration List Not Open"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    });
  }

  submitScrutiny() {
    this.spinner.show();
    this.submitpayload = this.ScrutinyPopForm.value;
    this.tabsString = ''
    let arr1 = [];
    if (this.submitpayload.Srty == 'APPR' && this.FinalApp == false) {
      this.Arr['ScrtLvl'] = parseInt(this.Arr['ScrtLvl']) + 1
      this.submitpayload.DocErrBy = null;
      this.tabsString = ''
    }
    else if (this.submitpayload.Srty == 'APPR' && this.FinalApp == true) {
      this.Arr['ScrtLvl'] = parseInt(this.Arr['ScrtLvl'])
      this.submitpayload.DocErrBy = null;
      this.tabsString = ''
    }
    else if (this.submitpayload.Srty == 'DCERR') {
      this.Arr['ScrtLvl'] = 1;
      this.submitpayload.DocErrBy = this.Arr['UserId'];
      this.tabsString = this.submitpayload.Tabs.join(', ');
      if(this.submitpayload.Tabs.includes('Document Upload')){
        this.docString = this.submitpayload.StuSrNo.join(',');
      }
      else{
        this.docString = ''
      }
      
    }
    else if (this.submitpayload.Srty == 'BCKP') {
      this.assignLevelData.forEach((element, i) => {
        if (element.AssignLevel == (this.Arr['ScrtLvl'] - 1)) {
          this.uuuID = element.UserId
        }
      });
      this.Arr['UserId'] = this.uuuID
      this.Arr['ScrtLvl'] = parseInt(this.Arr['ScrtLvl']) - 1
      this.submitpayload.DocErrBy = this.Arr['UserId'];
    }

      arr1.push(
        this.fb.group({
          Status: new FormControl(this.submitpayload.Srty),
          Comment: new FormControl(this.submitpayload.Text),
          ScrutinyLevel: new FormControl(this.Arr['ScrtLvl']),
          UserId: new FormControl(this.Arr['UserId']),
          ScrutinyId: new FormControl(this.Arr['ScrtId']),
          CoCode: new FormControl(this.Arr['CoCode']),
          CgCode: new FormControl(this.Arr['CgCode']),
          SessionId: new FormControl(parseInt(this.Arr['SessionId'])),
          StuId: new FormControl(this.Arr['StdId']),
          StuEmail: new FormControl(this.Arr['email']),
          UserLoginName: new FormControl(this.Arr['LoginName']),
          StuFirstName: new FormControl(this.Arr['FirstName']),
          StuMiddleName: new FormControl(this.Arr['MidName']),
          StuLastName: new FormControl(this.Arr['LastName']),
          CgName: new FormControl(this.Arr['CgName']),
          DocErrBy: new FormControl(parseInt(this.submitpayload.DocErrBy)),
          Tabs: new FormControl(this.tabsString),
          StuSrNo: new FormControl(this.docString),
          finalApp:new FormControl(this.FinalApp),
        })
      )
    let payload = { ...this.Arr, DocErrBy: parseInt(this.submitpayload.DocErrBy), Status: this.submitpayload.Srty, Comment: this.submitpayload.Text }
    this.umsService.updateScrutiny(arr1[0].value).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        //Step 4)after scrutiny api call check lock to see whether final approval done or not
        this.checkLock2();
        this.UpdateBtn = true;
        this.isdisabled = true;
        // this.RegnForm(); commented temporarily
        // this.redirect('scrutiny');
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngOnInit();
    });
 
  }

  checkLock2() {
    this.spinner.show()
    const payload = {};
    payload['UserId'] = parseInt(this.Arr['UserId']);
    payload['StudentId'] = parseInt(this.Arr['StdId']);
    payload['SessionId'] = parseInt(this.Arr['SessionId']);
    this.umsService.ScrutinyLock(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
        this.Data = res.data[0]
        this.submitpayload = this.ScrutinyPopForm.value;
        //Step 5)this condition checks whether final approval done by last level user or not
        if (this.submitpayload.Srty == 'APPR' && this.Data.FinalApproval == true && this.Arr['UserId'] == this.Data.HistoryUserId) {
          this.UpdateBtn = true;
          this.NewCoSch();
        }
      }
      else {
        this.spinner.hide()
        if (res.message == 'No Data Found') {
          this.isdisabled = true;
          this.UpdateBtn = true;
        }

      }
      
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });

  }

  NewCoSch() {
    this.spinner.show()
    const payload = {};
    payload['CoCode'] = this.Arr['CoCode'];
    payload['CShStatus'] = '';
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['CShSnNo'] = parseInt(this.Arr['SessionId']);
    this.umsService.NewCoSch(payload).subscribe(res => {
      if (res.status) {
        //step 6) if course is scheduled take its shid and check registration list
        this.spinner.hide()
        this.NewSearchCoSch(res.data[0]['CShId'])
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }

  NewSearchCoSch(ShId) {
    this.spinner.show()
    const payload = {};
    payload['CEcShId'] = ShId;
    this.umsService.NewSearchCoSch(payload).subscribe(res => {
      if (res.status) {
        //Step 7)registration list take its ecid and call registration api
        this.spinner.hide()
        this.RegnForm(res.data[0]['CEcId'])
      }
      else{
        this.spinner.hide()
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    });
  }


  RegnForm(EcId) {
    
    if(this.Arr['EmSrNo'] > 1){
      this.laterEntry = 'L'
    }
    else{
      this.laterEntry = ''
    }
    this.spinner.show()
    const SubValues = this.Arr['subjects'].join(',').trim();
    const payload = {};
    payload['CSExBr'] = '';
    payload['Code'] = '';
    payload['Colg'] = '';
    payload['valid'] = 'Y';
    payload['changed'] = '';
    payload['CgCodee'] = '';
    payload['Batch'] = '';
    payload['Name'] = this.Arr['FirstName'];
    payload['RgNo'] = this.Arr['stuRgNo'];
    payload['FormNo'] = '';
    payload['CgCode'] = this.Arr['CgCode'];
    payload['Chng'] = 'Y';
    payload['Valid'] = '';
    payload['Father'] = this.Arr['MidName'];
    payload['Mother'] = this.Arr['StuMothNameEng'] ? this.Arr['StuMothNameEng'] : '';
    payload['BirthDate'] = this.Arr['birthDate'];
    payload['Sex'] = this.Arr['StuGender'];
    payload['Cate'] = 'R';
    payload['Caste'] = this.Arr['StuConstiSubCate'] ? this.Arr['StuConstiSubCate'] : '';     //this.Arr['StuConstiSubCate']
    payload['EMail'] = this.Arr['EmailID'] ? this.Arr['EmailID'] : '';
    payload['Medium'] = 'E';
    payload['Nation'] = '1';
    payload['Mobile'] = this.Arr['StuNumber'] ? this.Arr['StuNumber'] : '';
    payload['Addr1'] = this.Arr['StuAddrC'] ? this.Arr['StuAddrC'] : '';
    payload['Addr2'] = '';
    payload['Addr3'] = '';
    payload['Addr1P'] = this.Arr['StuAddrP'] ? this.Arr['StuAddrP'] : '';
    payload['Addr2P'] = '';
    payload['Addr3P'] = '';
    payload['Pin'] = this.Arr['StuPinC'] ? this.Arr['StuPinC'] : '';
    payload['PinP'] = this.Arr['StuPinP'] ? this.Arr['StuPinP'] : '';
    payload['Place'] = '';
    payload['StrCode'] = this.Arr['StrCode'] ? this.Arr['StrCode'] : 0;
    payload['PlaceP'] = '';
    payload['ExSub'] = '';
    payload['Sub'] = SubValues;
    payload['EcId'] = EcId;
    payload['CoCode'] = this.Arr['CoCode'];
    payload['SnNo'] = parseInt(this.Arr['SessionId']);
    payload['EmSrNoF'] = this.Arr['EmSrNo'];
    payload['msg'] = '';
    payload['EmSkip'] = this.laterEntry; 
    payload['StuId'] = this.Arr['StdId'];
    //from this.Arr all data of student should be inserted in payload

    this.umsService.addRegiFormScrutiny(payload).subscribe((res) => {
      if (res.status) {
        //step 8) if registration done successfully then call validate api
        this.spinner.hide()
        this.Validate(EcId);

      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  Validate(EcId) {  
    //once validate api is called this student is considered as successfully inserted in registration table.
    this.spinner.show()
    const payload = {};
    payload['Batch'] = '';
    payload['EcId'] = EcId;
    payload['Inst'] = this.umsService.secretdata['ClubPartTrans'];
    this.umsService.validateRegiForm(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide()
      } else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  openStudentHistoryPopUP() {
    let data = {};
    data['StudentId'] = this.Arr['StdId'];
    this.dialogRef1 = this.dialog.open(StudentHistoryComponent, {
      disableClose: true,
      width: "900px",
      height: "600px",
      data,
    });
    this.dialogRef1.afterClosed().subscribe((result) => {
      // this.ngOnInit();
    });
  }

  Scrutiny(data) {
    
    if( this.Data.Status == 'APPR' && this.Data.FinalApproval == true && this.Arr['UserId'] == this.Data.HistoryUserId ){
      if(this.FeesBeforeScrutiny == true){
        this.UpdateBtn = false
        this.isdisabled = false
      }
      else if(this.FeesBeforeScrutiny == false){
        this.UpdateBtn = true
      }
      // this.UpdateBtn = true;
    }
    else{
      if (data == 'APPR') {
        this.showwMessage = false;
       this.UpdateBtn = false;
      this.ScrutinyPopForm.get('Text').clearValidators();
      this.ScrutinyPopForm.get('Text').updateValueAndValidity();
    }
    else if (data == 'DCERR') {
      this.showwMessage = false;
       this.UpdateBtn = false;
      this.ScrutinyPopForm.get('Text').setValidators(Validators.required);
      this.ScrutinyPopForm.get('Text').updateValueAndValidity();
    }
    else if (data == 'BCKP') {
      this.Previous();
    }
    }
   
    
  }

  Previous() {
    const payload = {};
    payload['CoCode'] = this.Arr['CoCode'];
    payload['CgCode'] = this.Arr['CgCode'];
    payload['SessionId'] = parseInt(this.Arr['SessionId']);
    this.umsService.getAssLvl(payload).subscribe((res) => {
      if (res.status) {
        this.assignLevelData = res.data
        
    //this condition is called to check whether there are multiple user level for scrutiny approval or single user
        if (res.data.length == 1) {
          this.UpdateBtn = true;
          this.showwMessage = true;
          this.errmessage = "You Can Not Send To Previous Level"
        }
        else {
          //if multiple level then the logged in user is first or not
          this.assignLevelData.filter(element => {
            if (this.Arr['UserId'] == element.UserId && element.AssignLevel == 1) {
              this.UpdateBtn = true;
              this.showwMessage = true;
              this.errmessage = "You Can Not Send To Previous Level"
            }
          });
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }



  toggleExamDropdown(selectedItem: any) {
    //this condition is used as tabs dropdown should be visible only when document error is selected
    this.TabVisible = false;
    if (selectedItem.CdCode === "DCERR") {
      this.TabVisible = true;
    } else {
      this.TabVisible = false;
    }
  }
 
  documenthinnedDropdown(selectedItems: any[]) {
    //if from tabs dropdown document upload tab is selected for error then documents dropdown should be visible
    if (selectedItems.includes("Document Upload")) {
        this.ScrutinyPopForm.get('StuSrNo').setValue('');
        this.documentDropdownVisible = true;
        this.selectedItems = selectedItems;
        this.fetchDocument();
    } else {
      this.tabselected = ''
        this.documentDropdownVisible = false;
    }
}
 
  fetchDocument() {
    this.spinner.show();
    let payload = {
      StuId: this.Arr['StdId']
    };
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.documentList = res.data;
        this.filtereddocumentList = this.documentList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  isOptionDisabled(item){
    if(this.FeesBeforeScrutiny == true){
      const REJT = 'REJT';
      const BCKP = 'BCKP';
      return item === REJT || item === BCKP;
    }
    else if(this.FeesBeforeScrutiny == false){
      return false
    }
  }
}